import React from 'react';
import PropTypes from 'prop-types';
import { useThemeTokensCallback } from '../ThemeProvider';
import LinkBase from './LinkBase';
import { jsx as _jsx } from "react/jsx-runtime";
const Link = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    href,
    children,
    accessibilityRole = 'link',
    variant = {},
    tokens,
    dataSet,
    ...linkProps
  } = _ref;
  const getTokens = useThemeTokensCallback('Link', tokens, variant);
  return /*#__PURE__*/_jsx(LinkBase, {
    href: href,
    accessibilityRole: accessibilityRole,
    tokens: getTokens,
    ref: ref,
    dataSet: dataSet,
    ...linkProps,
    children: children
  });
});
Link.displayName = 'Link';
Link.propTypes = {
  ...LinkBase.propTypes,
  /**
   * The dataSet prop allows to pass data-* attributes element to the component.
   */
  dataSet: PropTypes.object
};
export default Link;